export default __webpack_public_path__ + "static/media/leaf-bg.d376acc9.jpg";